// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blocked-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
  padding: 20px;
}
.blocked-page__content {
  max-width: 600px;
  text-align: center;
  width: 100%;
}
.blocked-page__title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #000000;
}
.blocked-page__text {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 16px;
  color: #000000;
}
.blocked-page__email {
  color: #0066cc;
  text-decoration: none;
}
.blocked-page__email:hover {
  text-decoration: underline;
}
.blocked-page__logout {
  color: white;
  background-color: rgb(14, 191, 255);
  border: 1px solid rgb(0, 184, 252);
  border-radius: 10px;
  height: 50px;
  padding: 0 24px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  margin-top: 32px;
  transition: background-color 0.3s ease;
}
.blocked-page__logout:hover {
  background-color: rgb(40, 141, 180);
}
.blocked-page__logout:disabled {
  background-color: rgb(40, 141, 180);
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/blockedPage/BlockedPage.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;AACF;AACE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;AACJ;AACE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AACJ;AACE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AACJ;AACE;EACE,cAAA;EACA,qBAAA;AACJ;AACI;EACE,0BAAA;AACN;AACE;EACE,YAAA;EACA,mCAAA;EACA,kCAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;AACJ;AACI;EACE,mCAAA;AACN;AACI;EACE,mCAAA;EACA,mBAAA;AACN","sourcesContent":[".blocked-page\n  display: flex\n  justify-content: center\n  align-items: center\n  min-height: 100vh\n  width: 100%\n  background-color: #ffffff\n  padding: 20px\n\n  &__content\n    max-width: 600px\n    text-align: center\n    width: 100%\n\n  &__title\n    font-size: 24px\n    font-weight: bold\n    margin-bottom: 20px\n    color: #000000\n\n  &__text\n    font-size: 16px\n    line-height: 1.6\n    margin-bottom: 16px\n    color: #000000\n\n  &__email\n    color: #0066cc\n    text-decoration: none\n\n    &:hover\n      text-decoration: underline\n\n  &__logout\n    color: white\n    background-color: rgb(14, 191, 255)\n    border: 1px solid rgb(0, 184, 252)\n    border-radius: 10px\n    height: 50px\n    padding: 0 24px\n    font-weight: bold\n    font-size: 16px\n    cursor: pointer\n    margin-top: 32px\n    transition: background-color 0.3s ease\n\n    &:hover\n      background-color: rgb(40, 141, 180)\n\n    &:disabled\n      background-color: rgb(40, 141, 180)\n      cursor: not-allowed\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
